

import TableDatePicker from 'components/PeriodSelection/DatePickerRange';
import SingleDatePicker from 'components/PeriodSelection/SingleDatePicker';
import { Filter } from 'filter';
import { useState } from 'react';
import Drawer from 'react-modern-drawer';
import { Modal } from 'react-responsive-modal';

export default function LogHistory(param: any) {

    const onCloseDrawer = () => {
        param.logChange();
    }

    const historylisting = [
        {
            "importId": "imp_001",
            "importedAt": "2026-02-08T09:14:22Z",
            "userName": "Alex Morgan",
            "fileName": "customers_jan.csv",
            "rowsCreated": 98,
            "rowsUpdated": 12,
            "rowsSkipped": 3,
            "reportDownloadUrl": "/reports/imp_001"
        },
        {
            "importId": "imp_002",
            "importedAt": "2026-02-09T16:41:07Z",
            "userName": "Jamie Lee",
            "fileName": "customers_feb.csv",
            "rowsCreated": 120,
            "rowsUpdated": 45,
            "rowsSkipped": 7,
            "reportDownloadUrl": "/reports/imp_002"
        },
        {
            "importId": "imp_003",
            "importedAt": "2026-02-10T11:03:55Z",
            "userName": "Taylor Kim",
            "fileName": "customers_mar.csv",
            "rowsCreated": 64,
            "rowsUpdated": 18,
            "rowsSkipped": 0,
            "reportDownloadUrl": "/reports/imp_003"
        }
    ]


    let [searchFor, SetSearch] = useState("");

    const dateSelection = (e: any) => {

    }
    return (<>

        <Modal open={param.logStatusOpen} onClose={() => onCloseDrawer()} styles={{ modalContainer: { background: 'transparent !important', width: "60% !important" } }} center classNames={{ overlay: '', modal: 'ws-7 paddingCenterBox bgTransparent' }} >
            <div className="box ws-12 landing">

                <div className="box-header  noBorderRadius bg-blue pLarge">
                    Log History
                </div>

                <div className='ws-12 pm'>

                    <div className='ws-12'>
                        <div className='ws-6 ps height35'>
                            <input type="text" className="ws-12 pull-right height30" value={searchFor} onChange={(e) => SetSearch(e.target.value)}
                                placeholder='Search by Filename , user' style={{ border: 'none', outline: 'none' }} />
                        </div>

                        <div className='ws-4 ps height35'> <TableDatePicker type={"range"} onChange={dateSelection} /> </div>

                        <button type="button" className="text-bold icon-btn info pull-right height35 width110" >Export</button>
                    </div>

                    <div className='ws-12 box mtl borderNone bgTransparent'>
                        <table className="newTable box">
                            <thead>
                                <tr>
                                    <th >date/time</th>
                                    <th >User</th>
                                    <th >File name</th>
                                    <th >Rows created/updated/skipped</th>
                                    <th >Download report</th>
                                </tr>
                            </thead>
                            <tbody>
                                {historylisting.map((row: any) => (
                                    <tr>
                                        <td>{Filter.DateTimeFormat(row.importedAt)}</td>
                                        <td>{row.userName}</td>
                                        <td>{row.fileName}</td>
                                        <td>
                                            <span className='ws-3'>{row.rowsCreated}</span>
                                            <span className='ws-1'>/</span>
                                            <span className='ws-3'>{row.rowsUpdated}</span>
                                            <span className='ws-1'>/</span>
                                            <span className='ws-4'>{row.rowsSkipped}</span>
                                        </td>
                                        <td>{row.reportDownloadUrl}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Modal>

    </>)
}